import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    TextField,
    Button,
    Typography,
    FormHelperText,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGlobalContext } from "../../context/Context";
import AddIcon from "@mui/icons-material/Add";
import Image from "../../Utils/getImage";
import GetLink from "../../Utils/GetLink";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Addstaff = ({ openDialog, setOpenDialog, edit, setEdit, selectedstaff, setEmployees }) => {
    const { loading, setLoading } = useGlobalContext();
    const [designation, setDesignation] = useState();


    // Conditional dialog title and description
    const title = edit ? "Edit Addstaff" : "Add Staff";
    const description = edit
        ? "Update Staff details."
        : "Add a new Staff to the list.";

    //handle close
    const handleClose = () => {
        setOpenDialog(false);
    };



    const handlegetDesignation = async () => {
        try {
            const response = await instance.get('/Staff/getDesignation');
            setDesignation(response.data.designation);
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        handlegetDesignation();
    }, []);
    // console.log("selectedstaff", selectedstaff);

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Staff Details
                    {/* <Typography>{description}</Typography> */}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <hr style={{ margin: "10px 0px" }} />
                <DialogContent dividers>
                    <section className="order-info-section-1">
                        <div className='order-info'>
                            <div className="add-employee-title">
                                {/* <Typography>Order Info</Typography> */}
                                <Typography variant='h5'>Customer Details</Typography>
                            </div>
                            <Grid
                                container
                                spacing={4}
                                sx={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                }}
                            >
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                    <div className="add_emloyee-upload-file">
                                        <Image src={selectedstaff?.Photo} alt="profile_pic" width={220} height={171} />
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                        <div className="add_emloyee-content" style={{ marginBottom: "20px" }}>
                                            <div className="add_emloyee-content-text-2">
                                                <Typography variant="h5">Name</Typography>
                                                <Typography>{selectedstaff?.Name}</Typography>
                                            </div>
                                            <div className="add_emloyee-content-text-2">
                                                <Typography variant="h5">Address</Typography>
                                                <Typography>{selectedstaff?.Address}</Typography>
                                            </div>
                                            <div className="add_emloyee-content-text-2">
                                                <Typography variant="h5">Mobile number</Typography>
                                                <Typography>{selectedstaff?.Phone}</Typography>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                        <div className="add_emloyee-content" style={{ marginBottom: "20px" }}>
                                            <div className="add_emloyee-content-text-2">
                                                <Typography variant="h5">Alternative Number</Typography>
                                                <Typography>{selectedstaff?.Alt_Phone}</Typography>
                                            </div>
                                            <div className="add_emloyee-content-text-2">
                                                <Typography variant="h5">Salary</Typography>
                                                <Typography>{selectedstaff?.Salary}</Typography>
                                            </div>
                                            <div className="add_emloyee-content-text-2">
                                                <Typography variant="h5">Years of Experience</Typography>
                                                <Typography>{selectedstaff?.YrsofExp}</Typography>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                        <div className="add_emloyee-content" style={{ marginBottom: "20px" }}>
                                            <div className="add_emloyee-content-text-2">
                                                <Typography variant="h5">Skills</Typography>
                                                <Typography>{selectedstaff?.Skills}</Typography>
                                            </div>
                                            <div className="add_emloyee-content-text-2">
                                                <Typography variant="h5">Specialities</Typography>
                                                <Typography>{selectedstaff?.Specialities}</Typography>
                                            </div>
                                            <div className="add_emloyee-content-text-2">
                                                <Typography variant="h5">Date of joining</Typography>
                                                <Typography>{selectedstaff?.DateofJoin}</Typography>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                    <div className="add_emloyee-upload-file">
                                        <GetLink href={selectedstaff?.ID_Proof} alt="profile_pic" width={220} height={171} >View ID Proof</GetLink>
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                    <div className="add_emloyee-upload-file">
                                        <GetLink href={selectedstaff?.Resume} alt="profile_pic" width={220} height={171} >View Resume</GetLink>
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                    <div className="add_emloyee-upload-file">
                                        <GetLink href={selectedstaff?.Address_Proof} alt="profile_pic" width={220} height={171} >View Address Proof</GetLink>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </section>
                </DialogContent>
            </BootstrapDialog>
        </React.Fragment >
    );
};

export default Addstaff;
